package one.healthium.insights.domain.models

import kotlinx.serialization.Serializable

@Serializable
data class ShoppingListModel(
    val id: String,
    val name: String?,
    val items: List<ShoppingItemModel>,
)

@Serializable
data class ShoppingItemModel(
    val id: String,
    val name: String,
    val category: String?,
    val emoji: String?,
    val quantity: String?,
    val unit: ShoppingItemUnitModel?,
)

@Serializable
data class ShoppingItemUnitModel(
    val metric: UnitModel?,
    val imperial: UnitModel?,
)

@Serializable
data class UnitModel(
    val amount: Double,
    val unit: String,
)